import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/operations')({
  staticData: { breadcrumb: 'Operations' },
  component: () => <Outlet />,
});
